import { securePaymentApi } from "@/service/axios";

const PATH = "commons/digital-business-card/public";

class DigitalBusinessCardService {
    async isValidLink(token, params) {
        try {
            const { data } = await securePaymentApi.get(
                `${PATH}/is-valid-link/${token}`,
                { params }
            );
            return data.valid;
        } catch (error) {
            throw error;
        }
    }

    async getLinkData(token, params) {
        try {
            const { data } = await securePaymentApi.get(
                `${PATH}/get-link-data/${token}`,
                { params }
            );
            return data;
        } catch (error) {
            throw error;
        }
    }

    async validateVCard(token, params) {
        try {
            return await securePaymentApi.head(
                `${PATH}/download-vcard/${token}`,
                {
                    params,
                }
            );
        } catch (error) {
            throw error;
        }
    }
}

export default new DigitalBusinessCardService();
